import { CheckIcon, ClockIcon, RefreshIcon, Spinner, XIcon } from './queueIcons'

/**
 * Maps the job-state vocabulary's `icon` key to a component.
 *
 * Lives in its own plain module (not queueIcons.jsx) because a file that exports
 * components must export ONLY components — a constant alongside them breaks
 * fast refresh (react-refresh/only-export-components).
 */
export const STATE_ICONS = {
  check: CheckIcon,
  x: XIcon,
  clock: ClockIcon,
  refresh: RefreshIcon,
  spinner: Spinner,
  dots: ClockIcon,
}

export default STATE_ICONS
